<template>
    <textarea
        ref="textarea"
        class="form-control"
        rows="1"
        :value="value"
        v-on:input="$emit('update:model-value', $event.target.value); autoExpand()"
        :placeholder="placeholder"
        />
</template>

<script>
// based on
// https://github.com/chryb/vue-expand
export default {
    props: {
        value: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        minRows: {
            type: Number,
            default: 1,
        },
    },
    mounted () {
        const textarea = this.$refs.textarea;
        const savedValue = textarea.value;

        textarea.value = '';
        textarea.baseScrollHeight = textarea.scrollHeight;
        textarea.value = savedValue;

        this.autoExpand();
    },
    methods: {
        autoExpand () {
            const textarea = this.$refs.textarea;
            textarea.rows = this.minRows;
            // TODO: calculate value
            // 14 -> 17 optimal
            // 16 -> 24 optimal
            const rows = Math.ceil((textarea.scrollHeight - textarea.baseScrollHeight) / 24);
            textarea.rows = this.minRows + rows;
        }
    },
};
</script>
